/* ==========================================================================
   PeekoraLab - Nike-style cart drawer layer - 2026-10-04

   Adds to the existing drawer (sections/pk-mini-cart.liquid + pk-mini-cart.js):
     1. "You might also like" - a horizontal, swipeable product rail with a
        one-tap "+" quick add. Multi-variant products open a chip picker
        instead of a native <select>.
     2. "Added to cart" feedback - the drawer title flips to a check mark and
        the line that was just added is highlighted, Nike-style.
     3. "Popular right now" rail in the empty cart.

   2026-10-14: the rail now shows EVERY product (not just three), with the
   most relevant add-on first (microscope -> SD card, MagicReveal -> brush,
   and so on), and each card carries a tag for that product's real automatic
   deal (see DEALS below). Prices are untouched - tags only describe the
   existing Shopify discounts, which all need 2 of the SAME product.

   HOW IT HOOKS IN - NO MutationObserver, NO edits to pk-mini-cart.js.
   pk-mini-cart.js renders exclusively from the JSON returned by /cart.js and
   /cart/change.js. This file wraps window.fetch and reads a CLONE of those
   same responses, so it sees exactly the cart the drawer just rendered and
   can never loop or race with it. /cart/add.js responses tell us which
   variant was just added (for the highlight).

   Offer engine untouched: adds go through /cart/add.js and then announce
   peekora:cart:changed + peekora:cart:updated, exactly like every other add
   in the theme, so pk-offer-eligibility reconciles gifts/tiers as usual.
   Meta AddToCart is fired by Shopify's native pixel on the AJAX add.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__PK_CART_NIKE__) return;
  window.__PK_CART_NIKE__ = true;

  var root = document.getElementById('PeekoraMiniCart');
  if (!root || !window.fetch) return;

  var BASE = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var FR = String(document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var GIFT_SKU = 'PEEKORA-MINISCOPE-FREE-GIFT';
  var FREE_SHIP_BASE = 6500; /* CA$65 in shop currency (cents) - mirrors the delivery profile */

  var SCOPE = 'peekorascope-explorer-kids-microscope';
  var SD = '32-gb-sd-card';
  var BOOK = 'peekora-magicreveal-water-coloring-book';
  var BRUSH = 'magicreveal-water-brush';
  var MINI = 'microscope-60-120x-lab-handheld-microscope-battery-powered-microscope-with-led-light-kids-science-microscope';
  var NEST = 'peekora-colornest-color-sorting-toy';
  var PRISM = 'peekora-prismatch-rainbow-matching-game';
  var TALK = 'peekoratalk-reader-bilingual-book';
  var FIT = 'peekora-nestwood-wooden-puzzle';

  /* Every product the rail may show, in default order. Accessories last. */
  var ALL = [SCOPE, BOOK, FIT, MINI, NEST, PRISM, TALK, SD, BRUSH];

  /* Short display names - product titles are long SEO titles. */
  var NAMES = {};
  NAMES[SCOPE] = 'PeekoraScope Explorer';
  NAMES[SD] = '32GB Microscope SD Card';
  NAMES[BOOK] = 'MagicReveal Water Colouring Book';
  NAMES[BRUSH] = 'Extra Magic Water Brush';
  NAMES[MINI] = 'MiniScope Pocket Microscope';
  NAMES[NEST] = 'ColorNest Sorting Toy';
  NAMES[PRISM] = 'PrismMatch Rainbow Game';
  NAMES[TALK] = 'PeekoraTalk Bilingual Book';
  NAMES[FIT] = 'FitNest Wooden Puzzle';

  /* Deal tags. Each mirrors an ACTIVE automatic discount in Shopify admin;
     all of them apply when the shopper buys 2 of the same product. Keep in
     sync if a discount is changed or ended.
       SCOPE  -> "Peekora Buy 2 - Save 25%" (and Buy 3 - Save 33%)
       others -> "<Product> - Buy 1 Get 1 50% Off" (and Buy 2 Get 1 Free)
     SD card and water brush have no deal, so no tag. */
  var DEAL_SCOPE = { en: 'Buy 2 · save 25%', fr: 'Achetez-en 2 · économisez 25 %' };
  var DEAL_HALF = { en: 'Buy 2 · 2nd 50% off', fr: 'Achetez-en 2 · 2e à -50 %' };
  var DEALS = {};
  DEALS[SCOPE] = DEAL_SCOPE;
  DEALS[BOOK] = DEAL_HALF;
  DEALS[MINI] = DEAL_HALF;
  DEALS[NEST] = DEAL_HALF;
  DEALS[PRISM] = DEAL_HALF;
  DEALS[TALK] = DEAL_HALF;
  DEALS[FIT] = DEAL_HALF;

  /* Most relevant first, then everything else in default order. */
  function withRest(first) {
    return first.concat(ALL.filter(function (h) { return first.indexOf(h) === -1; }));
  }

  /* What to recommend next, by what is in the cart. First match wins. */
  function priorities(cart) {
    var items = (cart && cart.items) || [];
    var has = function (h) { return items.some(function (i) { return i.handle === h; }); };
    var hasScope = items.some(function (i) { return /peekorascope/i.test(i.product_title || ''); });
    if (!items.length) return [SCOPE, BOOK, FIT, MINI, NEST, PRISM, TALK];
    if (hasScope) return withRest([SD, MINI, FIT, BOOK]);
    if (has(BOOK)) return withRest([BRUSH, FIT, SCOPE, NEST]);
    if (has(MINI)) return withRest([SCOPE, SD, FIT, BOOK]);
    if (has(FIT)) return withRest([PRISM, NEST, BOOK, SCOPE]);
    if (has(NEST)) return withRest([PRISM, FIT, BOOK, TALK]);
    if (has(PRISM)) return withRest([NEST, FIT, BOOK, TALK]);
    if (has(TALK)) return withRest([BOOK, NEST, PRISM, FIT]);
    if (has(BRUSH)) return withRest([BOOK]);
    if (has(SD)) return withRest([SCOPE]);
    return ALL.slice();
  }

  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
  var rate = Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', { style: 'currency', currency: currency }).format((Number(cents) || 0) / 100);
    } catch (e) { return '$' + ((Number(cents) || 0) / 100).toFixed(2); }
  }
  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[c];
    });
  }
  function t(en, fr) { return FR ? fr : en; }

  /* ---------- product data (cached per page view) ---------- */
  var cache = {};
  function loadProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch(BASE + 'products/' + handle + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }
  function sellable(p) {
    return (p.variants || []).filter(function (v) { return v.available && Number(v.price) > 0 && v.sku !== GIFT_SKU; });
  }
  function img(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------- DOM ---------- */
  var rail = document.createElement('section');
  rail.className = 'pkn-recs';
  rail.hidden = true;
  rail.setAttribute('aria-label', t('You might also like', 'Vous aimerez aussi'));
  rail.innerHTML =
    '<div class="pkn-recs__head"><h3 class="pkn-recs__title" data-pkn-title></h3>' +
    '<div class="pkn-recs__arrows"><button type="button" class="pkn-arrow" data-pkn-prev aria-label="' + t('Previous', 'Précédent') + '">&#8249;</button>' +
    '<button type="button" class="pkn-arrow" data-pkn-next aria-label="' + t('Next', 'Suivant') + '">&#8250;</button></div></div>' +
    '<div class="pkn-recs__list" data-pkn-list role="list"></div>' +
    '<div class="pkn-sheet" data-pkn-sheet hidden></div>' +
    '<p class="pkn-recs__status" data-pkn-status role="status" aria-live="polite"></p>';

  function mount() {
    var body = root.querySelector('.pkmc__body');
    if (!body || rail.parentNode === body) return;
    var secondary = body.querySelector('[data-pkmc-secondary]');
    if (secondary) body.insertBefore(rail, secondary); else body.appendChild(rail);
  }
  mount();

  var list = rail.querySelector('[data-pkn-list]');
  var sheet = rail.querySelector('[data-pkn-sheet]');
  var status = rail.querySelector('[data-pkn-status]');
  var titleEl = rail.querySelector('[data-pkn-title]');
  var lastCart = null;
  var lastSig = '';
  var products = {}; /* handle -> product json, for the chip sheet */
  var busy = false;

  function gapFor(cart) {
    var subtotal = typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : cart.total_price;
    return Math.max(0, Math.round(FREE_SHIP_BASE * rate) - Number(subtotal || 0));
  }

  var DEAL_STYLE = 'display:inline-block;margin:6px 6px 0 0;padding:3px 8px;border-radius:999px;background:#FFF1EC;color:#C4441F;font-size:11.5px;font-weight:800;line-height:1.3';

  function cardHtml(p, handle, gap, i) {
    var vs = sellable(p);
    var cheapest = vs.slice().sort(function (a, b) { return a.price - b.price; })[0];
    var compare = Number(cheapest.compare_at_price || 0);
    var name = NAMES[handle] || p.title;
    var multi = vs.length > 1;
    var unlocks = gap > 0 && cheapest.price >= gap;
    var deal = DEALS[handle];
    var url = BASE + 'products/' + handle;
    return '<article class="pkn-card" role="listitem">' +
      '<div class="pkn-card__media"><a href="' + esc(url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(img(p.featured_image, 180)) + '" alt="" width="80" height="80" loading="lazy"></a></div>' +
      '<div class="pkn-card__body"><a class="pkn-card__title" href="' + esc(url) + '">' + esc(name) + '</a>' +
      '<p class="pkn-card__price">' + (multi ? '<span class="pkn-card__from">' + t('From ', 'Dès ') + '</span>' : '') +
      '<strong>' + money(cheapest.price) + '</strong>' + (compare > cheapest.price ? ' <s>' + money(compare) + '</s>' : '') + '</p>' +
      (deal ? '<p class="pkn-card__deal" style="' + DEAL_STYLE + '">' + esc(FR ? deal.fr : deal.en) + '</p>' : '') +
      (unlocks ? '<p class="pkn-card__tag">' + t('Unlocks free shipping', 'Livraison gratuite débloquée') + '</p>' : '') +
      '<button type="button" class="pkn-card__add" data-pkn-add="' + esc(handle) + '" data-variant="' + (multi ? '' : cheapest.id) + '" aria-label="' + esc(t('Add ', 'Ajouter ') + name + (multi ? t(' - choose an option', ' - choisir une option') : '')) + '">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg><span>' + t('Add', 'Ajouter') + '</span></button></div></article>';
  }

  function render(cart) {
    if (!cart || !cart.items) return;
    lastCart = cart;
    mount();
    var empty = !cart.items.length;
    root.setAttribute('data-pkn-empty', empty ? 'true' : 'false');
    titleEl.textContent = empty ? t('Popular right now', 'Populaires en ce moment') : t('You might also like', 'Vous aimerez aussi');

    var inCart = cart.items.map(function (i) { return i.handle; });
    var wanted = priorities(cart).filter(function (h) { return inCart.indexOf(h) === -1; });
    var gap = empty ? 0 : gapFor(cart);
    var sig = wanted.join('|') + ':' + (gap > 0) + ':' + empty;
    if (sig === lastSig && list.children.length) { rail.hidden = false; refreshArrows(); return; }

    Promise.all(wanted.map(loadProduct)).then(function (results) {
      if (lastCart !== cart) return; /* a newer cart arrived while loading */
      var html = '';
      var count = 0;
      results.forEach(function (p, i) {
        if (!p || !p.available || !sellable(p).length) return;
        products[wanted[i]] = p;
        html += cardHtml(p, wanted[i], gap, i);
        count += 1;
      });
      lastSig = sig;
      closeSheet(true);
      if (count < 2) { rail.hidden = true; list.innerHTML = ''; return; }
      list.innerHTML = html;
      list.scrollLeft = 0;
      rail.hidden = false;
      refreshArrows();
    });
  }

  /* ---------- arrows (desktop only via CSS) ---------- */
  var prev = rail.querySelector('[data-pkn-prev]');
  var next = rail.querySelector('[data-pkn-next]');
  function refreshArrows() {
    prev.disabled = list.scrollLeft <= 2;
    next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
  }
  list.addEventListener('scroll', refreshArrows, { passive: true });
  prev.addEventListener('click', function () { list.scrollBy({ left: -list.clientWidth * 0.8, behavior: 'smooth' }); });
  next.addEventListener('click', function () { list.scrollBy({ left: list.clientWidth * 0.8, behavior: 'smooth' }); });

  /* ---------- chip sheet for multi-variant products ---------- */
  var sheetState = null;
  function openSheet(handle, trigger) {
    var p = products[handle];
    if (!p) return;
    var vs = sellable(p).slice().sort(function (a, b) { return a.price - b.price; });
    sheetState = { handle: handle, variant: vs[0], trigger: trigger };
    sheet.innerHTML =
      '<div class="pkn-sheet__head"><img src="' + esc(img(p.featured_image, 120)) + '" alt="" width="48" height="48">' +
      '<div><strong>' + esc(NAMES[handle] || p.title) + '</strong><span>' + t('Choose an option', 'Choisissez une option') + '</span></div>' +
      '<button type="button" class="pkn-sheet__close" data-pkn-sheet-close aria-label="' + t('Close', 'Fermer') + '">&times;</button></div>' +
      '<div class="pkn-sheet__chips" role="radiogroup">' + vs.map(function (v, i) {
        return '<button type="button" role="radio" class="pkn-chip' + (i === 0 ? ' is-on' : '') + '" aria-checked="' + (i === 0) + '" data-pkn-chip="' + v.id + '">' +
          '<span>' + esc(v.title) + '</span><b>' + money(v.price) + '</b></button>';
      }).join('') + '</div>' +
      '<button type="button" class="pkn-sheet__add" data-pkn-sheet-add>' + t('Add to cart', 'Ajouter au panier') + ' · <span data-pkn-sheet-price>' + money(vs[0].price) + '</span></button>';
    sheet.hidden = false;
    var first = sheet.querySelector('.pkn-chip');
    if (first) first.focus();
    sheet.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }
  function closeSheet(silent) {
    sheet.hidden = true;
    sheet.innerHTML = '';
    if (!silent && sheetState && sheetState.trigger && document.body.contains(sheetState.trigger)) sheetState.trigger.focus();
    sheetState = null;
  }

  /* ---------- add to cart ---------- */
  function add(variantId, button) {
    if (busy || !variantId) return;
    busy = true;
    status.textContent = '';
    if (button) { button.disabled = true; button.classList.add('is-busy'); }
    fetch(BASE + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || t('Could not add this item.', "Impossible d'ajouter cet article.")); });
      return fetch(BASE + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (c) { return c.json(); });
    }).then(function (cart) {
      if (button) { button.classList.remove('is-busy'); button.classList.add('is-done'); }
      closeSheet(true);
      document.dispatchEvent(new CustomEvent('peekora:cart:changed', { detail: { cart: cart } }));
      /* pk-mini-cart.js re-renders (and stays open) on this event. */
      document.dispatchEvent(new CustomEvent('peekora:cart:updated', { detail: { open: true } }));
    }).catch(function (e) {
      status.textContent = e.message;
      if (button) { button.disabled = false; button.classList.remove('is-busy'); }
    }).then(function () { busy = false; });
  }

  rail.addEventListener('click', function (e) {
    var plus = e.target.closest('[data-pkn-add]');
    if (plus) {
      e.preventDefault();
      var vid = plus.getAttribute('data-variant');
      if (vid) add(vid, plus); else openSheet(plus.getAttribute('data-pkn-add'), plus);
      return;
    }
    var chip = e.target.closest('[data-pkn-chip]');
    if (chip && sheetState) {
      sheet.querySelectorAll('.pkn-chip').forEach(function (c) { c.classList.remove('is-on'); c.setAttribute('aria-checked', 'false'); });
      chip.classList.add('is-on');
      chip.setAttribute('aria-checked', 'true');
      var p = products[sheetState.handle];
      sheetState.variant = sellable(p).filter(function (v) { return String(v.id) === chip.getAttribute('data-pkn-chip'); })[0];
      var priceEl = sheet.querySelector('[data-pkn-sheet-price]');
      if (priceEl && sheetState.variant) priceEl.textContent = money(sheetState.variant.price);
      return;
    }
    if (e.target.closest('[data-pkn-sheet-add]') && sheetState && sheetState.variant) {
      add(sheetState.variant.id, e.target.closest('[data-pkn-sheet-add]'));
      return;
    }
    if (e.target.closest('[data-pkn-sheet-close]')) closeSheet();
  });

  /* ---------- "Added to cart" feedback ---------- */
  var addedVariants = [];
  var addedTimer = null;
  var heading = root.querySelector('#pkmc-title');
  var addedEl = document.createElement('p');
  addedEl.className = 'pkn-added';
  addedEl.setAttribute('role', 'status');
  addedEl.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg><span>' + t('Added to cart', 'Ajouté au panier') + '</span>';
  if (heading && heading.parentNode) heading.parentNode.appendChild(addedEl);

  /* The heading itself is never rewritten - pk-mini-cart.js holds a live
     reference to the count <span> inside it. The check-mark line is a sibling
     that CSS swaps in while .pkn-just-added is on the drawer. */
  function flashAdded(cart) {
    if (!addedVariants.length) return;
    var ids = addedVariants.slice();
    addedVariants = [];
    root.classList.add('pkn-just-added');
    setTimeout(function () {
      (cart.items || []).forEach(function (item) {
        if (ids.indexOf(Number(item.variant_id)) === -1) return;
        var key = window.CSS && CSS.escape ? CSS.escape(item.key) : item.key;
        var row = root.querySelector('[data-pk-key="' + key + '"]');
        if (row) row.classList.add('pkn-row-added');
      });
    }, 60);
    clearTimeout(addedTimer);
    addedTimer = setTimeout(function () {
      root.classList.remove('pkn-just-added');
      root.querySelectorAll('.pkn-row-added').forEach(function (r) { r.classList.remove('pkn-row-added'); });
    }, 3200);
  }

  /* ---------- fetch tap ---------- */
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = nativeFetch.apply(this, arguments);
    var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    var isCart = /\/cart(\.js|\/change\.js|\/update\.js|\/clear\.js)(\?|$)/.test(url);
    if (!isAdd && !isCart) return promise;
    promise.then(function (response) {
      if (!response || !response.ok) return;
      response.clone().json().then(function (data) {
        if (isAdd) {
          var items = data && data.items ? data.items : (data && data.variant_id ? [data] : []);
          items.forEach(function (i) { addedVariants.push(Number(i.variant_id || i.id)); });
          return;
        }
        if (data && Array.isArray(data.items)) {
          /* Only build the rail while the drawer is showing - pk-mini-cart-upgrade.js
             fetches /cart.js on every page load, and that must not trigger product
             requests for a drawer nobody opened. open() always re-fetches /cart.js. */
          if (root.hidden) { addedVariants = []; return; }
          render(data);
          flashAdded(data);
        }
      }).catch(function () {});
    }).catch(function () {});
    return promise;
  };
  /* Keep the toString shape for any script that sniffs it. */
  try { window.fetch.toString = function () { return nativeFetch.toString(); }; } catch (e) {}

  /* Escape closes the chip sheet first, not the whole drawer. */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !sheet.hidden) { e.stopPropagation(); closeSheet(); }
  }, true);

  /* ---------- swipe down on the mobile sheet handle to close ---------- */
  var header = root.querySelector('.pkmc__header');
  var startY = null;
  if (header) {
    header.addEventListener('touchstart', function (e) { startY = e.touches[0].clientY; }, { passive: true });
    header.addEventListener('touchend', function (e) {
      if (startY === null) return;
      var dy = e.changedTouches[0].clientY - startY;
      startY = null;
      if (dy > 70 && window.matchMedia('(max-width: 749px)').matches && window.PeekoraMiniCart) window.PeekoraMiniCart.close();
    }, { passive: true });
  }

  /* Warm the product cache only when the shopper reaches for the cart or an
     add-to-cart button - not on every page view. */
  document.addEventListener('pointerdown', function (e) {
    if (!e.target.closest || !e.target.closest('a[href$="/cart"], .pkcv__add, .pkcv__mobile-bar button, [name="add"], form[action*="/cart/add"] [type="submit"]')) return;
    ALL.forEach(loadProduct);
  }, { passive: true, capture: true });
})();
